var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"caption round-medium card",attrs:{"href":"#","id":_vm.menu},on:{"click":function($event){return _vm.showModal()}}},[_c('div',{staticClass:"caption round-medium shadow-huge bottom-10"},[_c('img',{staticClass:"caption-image",attrs:{"src":'images/mpower-new/'+_vm.image}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }